export const CUSTOM_MODE_SOON_AS_POSSIBLE_VALUE = '0';
export const CUSTOM_MODE_NEXT_BUSINESS_DAY_VALUE = '1';
